export default "__VITE_ASSET__CRdachpb__"